// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SimpsonYDalila_wrapper__yg3aK"};